import axios from './axios';
import SETTINGS from '../settings'
export default {
    createSettingUser(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/settinguser`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    }
}